import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'durationFormatter'
})
export class DurationFormatterPipe implements PipeTransform {
  transform(timeInSec: number): string {
    let sec = timeInSec % 60;
    let min = Math.floor(timeInSec / 60) % 60;
    let hour = Math.floor(timeInSec / 3600);
    let days = Math.floor(timeInSec / 86400);

    const d = (days !== 0) ? (days + "d ") : "";
    const h = (hour !== 0) ? (hour.toString().padStart(2, "0") + "h ") : "00h ";
    const m = (min !== 0 || hour !== 0) ? (min.toString().padStart(2, "0") + "m ") : "00m ";

    return d + h + m + sec.toString().padStart(2, "0") + "s";
  }
}